// Angular
import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

// Ngrx
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';

// Actions
import * as routerActions from '../../../store/router/router.actions';
import * as mainActions from '../../../store/dashboard/main/main.actions';

// Service
import { SoledadAuthenticationService } from './auth.service';
import { RouterState } from '../../../store/router/router.state';
import { Subscriber } from '../../lib/helpers/subscriber';

@Injectable()
export class AuthGuard extends Subscriber implements CanActivate {
    routerState: RouterState;

    constructor(private authService: SoledadAuthenticationService, private store: Store<AppState>) {
        super();
        this.addSubscription(
            this.store
                .select((state) => state.router)
                .subscribe((data) => {
                    this.routerState = Object.assign({}, data.state);
                    this.routerState.url = this.routerState.url.replace(/\?[^$]*/g, '');
                })
        );
    }

    canActivate(): boolean {
        // Comprobación de login
        if (!this.authService.isLoggedIn()) {
            // Si la url cargada inicialmente contiene dashboard se guarda el
            // estado en state para posterior redirección
            if (this.routerState.url.search('dashboard')) {
                this.store.dispatch(
                    new mainActions.DoSetPreLogin({
                        preLogin: this.routerState,
                    })
                );
            }

            // Redirección a login
            this.store.dispatch(
                new routerActions.Go({
                    path: ['login'],
                })
            );

            return false;
        }
        return true;
    }
}
